export const environment = {
  production: false,
  apiUrl: 'https://dev.api.privaci.io/api',
  // Deployed development builds and `ng serve` use this file; local full-stack work uses
  // `ng serve --configuration local` (environment.local.ts).
};
